export const GET_RESERVATION_DATE = 'GET_RESERVATION_DATE';
export const GET_RESERVATION_DATE_REQUEST = `${GET_RESERVATION_DATE}_REQUEST`;
export const GET_RESERVATION_DATE_SUCCESS = `${GET_RESERVATION_DATE}_SUCCESS`;
export const GET_RESERVATION_DATE_FAILURE = `${GET_RESERVATION_DATE}_FAILURE`;

export const GET_RESERVATION_DATE_CHECK_DATA = `${GET_RESERVATION_DATE}_CHECK_DATA`;
export const GET_RESERVATION_DATE_CHECK_DATA_SUCCESS = `${GET_RESERVATION_DATE}_CHECK_DATA_SUCCESS`;
export const GET_RESERVATION_DATE_CHECK_DATA_FAILURE = `${GET_RESERVATION_DATE}_CHECK_DATA_FAILURE`;
